import { ChevronDown, Plus } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { OPCIONES_SIMPLES, type OpcionNuevo } from './tipos';

/** Botón «Nuevo» con un menú por tipo de contenido. */
export function MenuNuevo({
  compuestos,
  onElegir,
}: {
  compuestos: OpcionNuevo[];
  onElegir: (o: OpcionNuevo) => void;
}) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="btn-cs btn-primario">
        <Plus size={16} aria-hidden /> Nuevo <ChevronDown size={14} aria-hidden />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {compuestos.length > 0 && (
          <>
            <DropdownMenuLabel>Con su propia pantalla</DropdownMenuLabel>
            {compuestos.map((o) => (
              <DropdownMenuItem key={o.tipo} onSelect={() => onElegir(o)}>
                {o.etiqueta}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuLabel>En un modal</DropdownMenuLabel>
        {OPCIONES_SIMPLES.map((o) => (
          <DropdownMenuItem key={o.tipo} onSelect={() => onElegir(o)}>
            {o.etiqueta}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
